import * as angular from 'angular';
import {IController} from "angular";
import * as _ from "lodash";
import {RouteStatusEnum} from "../../enums/route-status.enum";

export class RouteStatusMultiSelectListComponent implements IController {
  statuses: RouteStatusEnum[];
  options: any;
  ngPlaceholder: any;
  onChange: Function;

  private selectedKeys: any;

  constructor() {
  }

  $onInit() {
    if (!this.options || !this.options.length) {
      this.options = angular.copy(Object.values(RouteStatusEnum));
    }
  }

  $onChanges(changes) {
    if (changes.statuses) {
      this.selectedKeys = [];
      _.forEach(this.statuses, (status) => {
        this.selectedKeys[status] = true;
      })
    }
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  onToggle(option, isSelected) {
    this.onChange({
      statuses: isSelected ? _.concat(this.statuses || [], [option]) :
        _.filter(this.statuses, (status) => {
          return status !== option;
        })
    });
  }

  onReset() {
    this.onChange({statuses: []});
  }

}

angular
  .module('bringoz.admin.routes')
  .component('routeStatusMultiSelectList', {
    bindings: {
      statuses: '<',
      options: '<?',
      ngPlaceholder: '@?',
      onChange: '&'
    },
    template: require('./route-status-multi-select-list.html').default,
    controller: RouteStatusMultiSelectListComponent
  });


